export default __webpack_public_path__ + "static/media/calculadora.f267c6a8.svg";